<template>
  <div class="share-notes" role="presentation">
    <form>
      <label for="share_note_first_name">{{ $t('notes.firstName') }}</label>
      <input id="share_note_first_name" type="text" placeholder="Joe" v-model="formData.firstName" name="firstName">
      <label for="share_note_last_name">{{ $t('notes.lastName') }}</label>
      <input id="share_note_last_name" type="text" placeholder="Smith" v-model="formData.lastName" name="lastname">
      <label for="share_note_email">{{ $t('socialMedia.email') }}</label>
      <input id="share_note_email" type="email" placeholder="joe@smith.com" v-model="formData.email" name="email">
      <div class="opt-in" v-if="isNCEnabled" role="presentation">
        <input id="optin" type="checkbox" v-model="formData.ncOptIn">
        <label for="optin">{{ $tr(shareForm.optin_message) }}</label>
      </div>
    </form>
    <button type="submit" @click="shareNotes" class="btn btn-primary main-background secondary-text">{{ $t('button.emailMyNotes') }}</button>
    <div class="overlay" v-if="emailSent" role="dialog" aria-label="Email sent">
      <div class="success-popup" role="presentation">
        <h3>{{ $t('notes.success') }}</h3>
        <p>{{ $t('notes.notesEmailed') }}</p>
        <button class="btn btn-primary main-background" @click="closePopup">{{ $t('button.ok') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NoteForm',
  data () {
    return {
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        ncOptIn: false
      },
      emailSent: false
    }
  },
  computed: mapState({
    ...mapState({
      shareForm: state => state.college.settings.share_form,
      isNCEnabled: state => state.college.namecaptureToken != null
    })
  }),
  methods: {
    shareNotes: function () {
      this.axios.post(`/email/notes/${this.$store.state.student.student}`, this.formData).then(response => {
        if (response.data.success) {
          this.emailSent = true
          this.$nextTick(() => this.$focusInsidePopup())
        }
      })
    },
    closePopup: function (event) {
      this.emailSent = false
      this.$nextTick(() => {
        if (event.pointerType === "mouse" || (event.type === 'keypress' && event.keyCode === 13) ) {
          this.$focusOutsidePopup()
        }
      })
    }
  }
}
</script>
